module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12trxNx/tc-custom/9781685506872.jpg?1723592050912",
      "alt": "This image is the cover for the book Midwinter Marriage"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Midwinter Marriage\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Honorable Edmund Rookwood needs to get married. By Midwinter. Or his father will disinherit him."), _c('br'), _c('br'), _vm._v("Edmund has always tried to be a loyal son and dutiful heir -- unlike his scandalous younger brother. But his father’s ultimatum seems impossible. Edmund has never fallen in love easily, and -- according to his father -- he’s a disappointment, inadequate, never good enough. Who would ever say yes to him?"), _c('br'), _c('br'), _vm._v("Sebastian Melior, the Duke of Morinbrough, mathematician and inventor and Edmund’s best friend, offers to help. After all, Sebastian’s also unmarried, and they’ve known each other for years. So Sebastian’s proposal is a logical solution ..."), _c('br'), _c('br'), _vm._v("But this Midwinter marriage of convenience stirs up unexpected emotions. And Edmund and Sebastian just might discover they’ve been each other’s answers all along.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      K.L. Noone\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0